import { useMemo } from 'react'
import { cmsDataService } from '@/common/services/cms.data.service'

export const useInitialData = () => {
    return useMemo(() => cmsDataService.get(), [])
}

export const useInitialDataHeader = () => useInitialData().header
